export enum FirebaseAuthErrorType {
  ExpiredCode = 'auth/expired-action-code',
}
